// copy from @mmodboard/theme/pxToRem
import pxToRemNum from './pxToRemNum';

const pxToRem = (size: number): string => {
  // REM_VALUE (9.79) - is the value of 1 rem this is adjustable
  return `calc(var(--rem) * ${pxToRemNum(size)})`;
};

export default pxToRem;
